import React, { useState, useEffect, useRef }  from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import GTMHelper from '../../../Helpers/gtmHelper';

export const CollapseSpecs = ({ColCarText1, ColBoxText, id, ...props }) => {
	const gtmHelper = new GTMHelper();

    const [toggle, setToggle] = useState(true);
    const [currID, setID] = useState(id);
    const collapseRef = useRef();

    useEffect(() => {
        const collapse = collapseRef.current;
        if(typeof window.mzAnimator === 'object'){
            window.mzAnimator.animateHeight(collapse, 'CollapseListSpecs' + currID, 'init')
        }
    }, [])

    useEffect(() => {
        const collapse = collapseRef.current;
        if(toggle){
            window.mzAnimator.animateHeight(collapse, 'CollapseListSpecs' + currID, false)
        }else{
            window.mzAnimator.animateHeight(collapse, 'CollapseListSpecs' + currID, true)
        }
        gtmHelper.setGTM({'action':'Collapse', 'type': 'Specs', 'value': toggle, 'title': ColCarText1}, true , false);
    },[toggle])

    return (
        <div className="mz-collapse mz-collapse--specs">
            <button
                onClick={()=>{setToggle(!toggle)}}
                className="mz-collapse__button"
            >
                <div className="mz-collapse__cartext-container">
                    <p className="mz-collapse__text">{ColCarText1}</p>
                </div>
                <i className={ !toggle ? "mz-svg mz-svg-chevron open" : "mz-svg mz-svg-chevron"}></i>
            </button>
            <div className="mz-collapse__box visible" ref={collapseRef}>{ ReactHtmlParser (ColBoxText) }</div>
        </div>
    )
}

CollapseSpecs.propTypes = {
    ColCarText1: PropTypes.string,
    ColBoxText: PropTypes.string,
}

CollapseSpecs.defaultProps = {
    ColCarText1: 'Term: 60 months @2.95%',
    ColBoxText: 'Pellentesque in ipsum id orci porta dapibus. Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Nulla porttitor accumsan tincidunt. Cras ultricies ligula sed magna dictum porta. Nulla quis lorem ut libero malesuada feugiat. Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Quisque velit nisi, pretium ut lacinia in, elementum id enim. Nulla porttitor accumsan tincidunt. Sed porttitor lectus nibh. Proin eget tortor risus.',
}

export default CollapseSpecs;